var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 43,
    viewBox: "0 0 86 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0804 35.8184V22.6932L27.6153 37.8577L35.4025 39.4966L22.5826 25.5735L40.2483 40.2917L53.2023 42.0104L25.5308 25.063L60.119 42.2097L85.7499 42.6667L20.8708 21.3333L85.7499 0L60.119 0.456971L25.5308 17.6037L53.2023 0.65635L40.2483 2.37498L22.5827 17.093L35.4025 3.17012L27.6153 4.809L19.0804 19.9735V6.97656L13.8212 8.692V34.103L19.0804 35.8184Z",
    fill: "#000E4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48026 31.9417V10.8533L12.0398 9.33406V33.4618L8.48026 31.9417Z",
    fill: "#000E4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03131 13.1189V29.6768L6.70113 31.0693V11.7257L4.03131 13.1189Z",
    fill: "#000E4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0256548 26.9286L0.0256348 15.8664L2.47324 14.2108L2.47325 28.5842L0.0256548 26.9286Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAzul);
export default __webpack_public_path__ + "static/media/logoAzul.d1bd61fe721ab28e2b178f397803aa36.svg";
export { ForwardRef as ReactComponent };